// extracted by mini-css-extract-plugin
module.exports = {"preview":"AuthorPreview_preview__683EZ","avatar":"AuthorPreview_avatar__P4fiS","name":"AuthorPreview_name__XOF0R","extra":"AuthorPreview_extra__6b916"};